import { render, staticRenderFns } from "./ObiSidebar.vue?vue&type=template&id=038ad368&scoped=true&"
import script from "./ObiSidebar.vue?vue&type=script&lang=js&"
export * from "./ObiSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ObiSidebar.vue?vue&type=style&index=0&id=038ad368&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038ad368",
  null
  
)

export default component.exports